import { AddressTypeEnum } from '../enums/AddressTypeEnum';

export class AddressDto {
  id: number;
  addressType: AddressTypeEnum;
  dutchStreet: string;
  dutchZipCode: string;
  dutchCity: string;
  dutchNumber: string;
  dutchSuffix: string;
  internationalStreet: string;
  internationalZipCodeCity: string;
  internationalCountry: string;

  constructor() {
    this.addressType = AddressTypeEnum.AddressDutch;
  }
}
